<template>
  <v-card>
    <v-toolbar color="primary" flat dark dense>
      <v-toolbar-title class="ml-2">Change History</v-toolbar-title>
      <v-subheader>[{{title}}] Revision History</v-subheader>
      <v-spacer/>
      <v-btn fab dark small color="red" @click="$emit('close')">
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <template v-if="!hasRevisions">
      <v-card class="mx-auto mt-6" width="80%">
        <v-toolbar color="grey" flat dark dense>
          <h3>No Change History</h3>
        </v-toolbar>
      </v-card>
    </template>
    <template v-for="version in value">
      <v-card v-bind:key="version.change_date" class="mx-auto mt-6" width="80%">
        <v-toolbar :color="eventColor(version.event)" flat dark dense>
          <v-toolbar-title class="ml-2">{{version.event | titleize}}</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-title class="ml-2">{{formatDate(version.change_date)}}</v-toolbar-title>
        </v-toolbar>
        <v-subheader>By {{version.user.name}} - {{version.user.email}}</v-subheader>
        <v-simple-table
          fixed-header
          max-height="600px"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Field Name
                </th>
                <th class="text-left">
                  Old Value
                </th>
                <th class="text-left">
                  New Value
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(changeSet, fieldName) in version.changes" :key="'cset' + fieldName">
                <td class="text-left">{{ fieldName }}</td>
                <td class="text-left"><pre>{{ formatChange(changeSet[0]) }}</pre></td>
                <td class="text-left"><pre>{{ formatChange(changeSet[1]) }}</pre></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </template>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'change-history',
  props: {
    value: {
      type: Array,
      require: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    }

  },
  data () {
    return {

    }
  },
  computed: {
    hasRevisions () {
      return this.value && this.value.length > 0
    }
  },
  methods: {
    formatChange (cset) {
      if (typeof cset === 'string') {
        return cset
      } else {
        return JSON.stringify(cset, null, 2)
      }
    },
    eventColor (eventName) {
      if (eventName === 'create') {
        return 'green'
      } else if (eventName === 'update') {
        return 'orange'
      } else {
        return 'red'
      }
    },
    formatDate (dt) {
      return DateTime.fromISO(dt).toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS)
    }
  }
}
</script>
